import { Modal } from 'antd';

const CustomModal = ({ handleOpen, open, children, className = "modal skill_modal", flag }) => {
    return (
        <Modal maskClosable={false} className={className} footer={null} visible={open} onCancel={() => flag ? handleOpen(flag) : handleOpen()}>
            <div className="modal_dialog">
                {children}
            </div>
        </Modal>
    )
};

export default CustomModal